module.exports = __webpack_public_path__ + "media/tâa yàang née rîak wâa dòot nom.8c0dda68.mp3";